import Certificate from './certificate';

const templates = [
  {
    id: 'DEFAULT_DIPLOMA',
    label: 'Document',
    template: Certificate,
  },
];

export default templates;
